import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from '../shared/config/app-config';
import { Errors, UserService } from '../shared';
import { User } from '../shared/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'signup-page',
  templateUrl: './signup.component.html',
  styleUrls: ['./style.css']

})
export class SignupComponent implements OnInit {
  session: boolean = false;
  authType: string = '';
  title: string = '';
  errors: Errors = new Errors();
  isSubmitting = true;
  authForm: FormGroup;
  type: string = 'email';
  public idletime: any = environment.idletime;
  public setidletime: any = environment.timeset;
  show = false;
  username: any = "";
  password: any = "";
  remember: any = false;
  code: any;
  ipBlocked = true;
  ipBlockedDetails: any;
  public name: any;
  public css: any;
  public csslogo: any;
  public cssbgimg: any;
  public apiurl: any = environment.api_url;
  setmask: string;
  language: any;
  helpDeskNo: any;
  public imageURL: string = environment.cloudeImageURL;
  public CurrentUser: User;
  /* username:any ="hospital@solvedge.in";
  password:any ="demo";
 */
getPrefLang = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    private idle: Idle,
    private keepalive: Keepalive,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userService.defaultLang);
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      'username': ['', Validators.required],
      'code': ['']
    });
  }


  ngOnInit() {
    if (navigator.userAgent.search("iPhone") != -1 && location.href.search("changepassword") == -1) {
      this.router.navigateByUrl('/appstore')
    }


    this.route.params.subscribe(params => this.name = params);
    if (this.name.name != 'AUTH') {
      this.userService.getclient(this.name.name).subscribe(css => {

        this.css = css;
        this.csslogo = this.css.logo;
        this.cssbgimg = this.css.bgimg;
        this.language = this.css.language;
        this.helpDeskNo = this.css.helpDeskNo
      });
    } else {
      this.csslogo = './assets/img/Omg.png';
      this.cssbgimg = './assets/img/rc_bg.jpg'
      this.language = 'en_us'
      this.helpDeskNo = '1-630-560-6805'
    }


    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )

    this.route.params.subscribe(params => this.name = params);

    this.userService.getclient(this.name.name).subscribe(css => {

      this.css = css;
      this.csslogo = this.css.logo;
      this.cssbgimg = this.css.bgimg;
    });
    if (window.localStorage['session']) {
      this.session = true;
    }
    if (environment.ipBlocked) {
      this.userService.getIPAccess().subscribe(data => {
        this.ipBlockedDetails = data;
        //this.ipBlockedDetails.allowsite =   "no";

        if (this.ipBlockedDetails.allowsite == "no")
          this.ipBlocked = false;
        else
          this.ipBlocked = true;
      },
        err => {
          this.errors = err;
        }
      );
    }
    else {
      this.ipBlocked = true;
    }

  }
  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  submitForm() {
    this.isSubmitting = true;
    this.errors = new Errors();
    let username = this.authForm.value.username
    if (this.authForm.value.code) {
      username = this.authForm.value.code + '-' + this.authForm.value.username
    }
    if(!this.getPrefLang) {
      this.getPrefLang = true;
      this.getPreferredLanguage(username, true);
      return;
    }
    this.userService
      .getuserinfologin(username)
      .subscribe(

        data => {
          this.navigateUser(data);
        }
      );
  }

  navigateUser(data) {
    if (data.randId && data.status && data.userGroupId == 19) {
      window.localStorage['firsttimeuser'] = 1
      window.localStorage['mail'] = this.authForm.value.username;
      this.router.navigateByUrl(`/welcome/${data.randId}`)
    }
    else if (data.randId && data.status && data.userGroupId == 20) {
      window.localStorage['firsttimeuser'] = 1
      this.router.navigateByUrl(`/intro/${data.randId}`)
    }
    else if (data.randId && data.status && data.userGroupId != 19 && data.userGroupId != 20) {
      window.localStorage['firsttimeuser'] = 1
      window.localStorage['randId'] = data.randId//////console.log(data);
      this.router.navigateByUrl(`/uservalidate`)
    }
    else {
      this.errors = data;
      this.isSubmitting = false;
      this.authForm.value.code = '';
    }
  }
  getPreferredLanguage(targetEmail, comeForSubmit = false) {
    const credential = {
      'userName': targetEmail
    }
    this.userService.getLanguageConfig(credential).subscribe(
      langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          if(langConfigRes?.multiLanguageRequired) {
            this.userService.setCurrentLanguage(langConfigRes?.preferredlanguage)
          }
        }
        if(comeForSubmit) this.submitForm()
    }, (err:any) => {
    });
  }

  public customPatterns = { 'A': { pattern: new RegExp('\[a-zA-Z0-9._@+-\]') }, '0': { pattern: new RegExp('\[0-9\]') } };
  Onchange(event) {
    if (event.keyCode != 8) {
      let targetvalue = event.target.value.replace(/[^a-zA-Z0-9._@+]/g, '');
      let keyvalue;
      if (event.key)
        keyvalue = event.key.replace(/[^a-zA-Z0-9._@+]/g, '');
      //if ((isNaN(targetvalue) || targetvalue == '') || (isNaN(keyvalue) || keyvalue == '')) {
      if (isNaN(targetvalue) || targetvalue == '' || isNaN(keyvalue) || keyvalue == '') {
        this.setmask = "A*"
        this.type = 'email'
      } else
        this.type = 'number'
    }
    else {
      if (event.target.value.length <= 0) {
        this.type = 'email'
        this.setmask = "A*"
      }
    }
    if (this.type == 'email')
      this.code = undefined
    else {
      if (this.code == '1' || this.code == undefined || this.code == null) {
        this.code = '1'
        this.checkphone('1')
      }
      else {
        this.checkphone(this.code)
      }
    }

  }
  checkphone(code) {
    if (this.type == 'number') {
      if (code == "44") {
        this.setmask = '00000 000000'
      } else {
        this.setmask = '(000) 000-0000'
      }
    }
  }
  getFullYear() {
    return new Date().getFullYear();
  }
  setvalue() {
    if (this.type != 'number') {
      return false
    } {
      return true
    }
  }
  signIn() {
    if (this.name.name == 'AUTH')
      this.router.navigateByUrl(`/login`)
    else
      this.router.navigateByUrl(`/plogin/${this.name.name}`)
  }


  signUp(username) {
    if (username) {
      this.userService
        .getuserinfologin(username)
        .subscribe(

          data => {
          },
          err => {
            this.errors = err;
            this.isSubmitting = false;
            this.authForm.value.code = '';
            /* this.errors.message.replace('Authentication Failed:','') */
          }
        );
    }
  }

  needHelp() {
    this.userService.loadEmailPopup();
  }

  patchUserName() {
    if(this.authForm.value.username && this.authForm.value.username.length > 1) {
      this.authForm.patchValue({username:''});
    }
  }
}
